import type { Provider } from '../api/my-account';

const DEFAULT_PROVIDER = 'pelckmans';
const BASE_URL = process.env.REACT_APP_DOCEO_TEMPLATE_URL;

export const buildDoceoUrl = (
  slideSet: { id: number; versionId?: number; state?: string },
  accountProvider?: Provider,
  isEditMode?: boolean,
  eventSubLocation?: string,
): string => {
  const provider = accountProvider || DEFAULT_PROVIDER;

  const query = new URLSearchParams();
  if (isEditMode) query.set('edit', isEditMode.toString());
  if (eventSubLocation) query.set('origin', eventSubLocation);
  if (slideSet.state !== undefined && slideSet.state !== 'PUBLISHED' && slideSet.versionId)
    query.set('versionId', slideSet.versionId.toString());

  const url = isEditMode === undefined ? BASE_URL : `${BASE_URL}/overview`;
  return `${url.replace(':provider', provider).replace(':id', slideSet.id.toString())}?${query}`;
};

export const buildDoceoUrlForSlide = (
  slideSet: { id: number; versionId?: number; state?: string },
  slideId: string,
  slideSetVersionGroup: string,
  accountProvider?: Provider,
  isEditMode?: boolean,
  eventSubLocation?: string,
): string => {
  const baseDoceoUrl = buildDoceoUrl(slideSet, accountProvider, isEditMode, eventSubLocation);
  const splittedUrl = baseDoceoUrl.split('?');
  return splittedUrl[0] + `/${slideSetVersionGroup}/${slideId}` + (slideSet.versionId ? '?' + splittedUrl[1] : '');
};

export const buildCopySlideSetUrl = (
  moduleId: string,
  nodeId: string,
  slideSetId: number,
  versionId: number,
  accountProvider?: Provider,
  eventSubLocation?: string,
): string => {
  const provider = accountProvider || DEFAULT_PROVIDER;

  const query = new URLSearchParams({ moduleId, nodeId, versionId: versionId.toString() });
  if (eventSubLocation) query.set('origin', eventSubLocation);

  return `${BASE_URL.replace(':provider', provider).replace(':id', slideSetId.toString())}/copy?${query}`;
};

export const buildNewSlideSetUrl = (
  moduleId: string,
  nodeId: string,
  eventSubLocation: string,
  accountProvider?: Provider,
): string => {
  const provider = accountProvider || DEFAULT_PROVIDER;

  const query = new URLSearchParams({
    moduleId,
    nodeId,
    origin: eventSubLocation,
  });

  return `${BASE_URL.replace(':provider', provider).replace(':id', 'new')}?${query}`;
};
